import styles from './Header.module.scss';

import { Blur } from '@/components';
import { useHapticFeedback } from '@/hooks/useHapticFeedback';
import { useNavigation } from '@/hooks/useNavigation';
import { PAGE } from '@/modules/page/routes';
import WalletIcon from '@/shared/icons/wallet.png';
import { useStore } from '@/store';
import { formatNumber } from '@/utils';
import { isTelegramApp } from '@/utils/isTelegramApp';
import cn from 'classnames';

import Usd from './images/usd.svg?react';
import Vote from './images/vote.svg?react';
import CloseIcon from '@/modules/polls/components/FilterBar/images/close.svg?react';
import {
  hideBackButton,
  isBackButtonMounted,
  mountBackButton,
  on,
  showBackButton,
} from '@telegram-apps/sdk-react';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';

export const Header = observer(() => {
  const { triggerHapticFeedback } = useHapticFeedback();
  const { currentPage, goTo, goBack, currentRoute, params } = useNavigation();
  const rootStore = useStore();

  const {
    accountStore: { accountData },
    walletStore: { totalBalance },
    shouldSupportFullscreen,
  } = useStore();
  const { tokens } = accountData;

  useEffect(() => {
    if (isTelegramApp()) {
      const hasBackButton =
        typeof currentRoute?.hasBackButton === 'function'
          ? currentRoute?.hasBackButton(params, rootStore)
          : currentRoute?.hasBackButton;
      if (hasBackButton) {
        mountBackButton();
        showBackButton();
      } else if (isBackButtonMounted()) {
        hideBackButton();
      }
    }
  }, [currentRoute]);

  useEffect(() => {
    const backButtonListener = on('back_button_pressed', () => {
      goBack();
    });
    return () => backButtonListener();
  }, [currentPage]);

  const handleClickBalances = () => {
    triggerHapticFeedback('medium');
    goTo(PAGE.WALLET);
  };

  const showOpinionSliderCloseButton = false;

  const onCloseClick = () => {
    triggerHapticFeedback('medium');
    goBack();
  };

  return (
    <header
      className={cn(
        styles.header,
        !shouldSupportFullscreen && styles.dsktpHeader,
      )}
    >
      <Blur />
      <h2
        className={cn(styles.title, currentRoute?.lightHeader && styles.light)}
      >
        {currentRoute?.title}
      </h2>
      {currentPage !== PAGE.UGC && (
        <div className={styles.currencies}>
          <div
            className={styles.currenciesContainer}
            onClick={handleClickBalances}
          >
            <div className={styles.walletIcon}>
              <img width={30} height={30} src={WalletIcon} alt="" />
            </div>
            <div className={styles.currencyWrapper}>
              <Vote />
              {formatNumber(tokens ?? 0)}
            </div>
            <div className={styles.currencyWrapper}>
              <Usd />
              {totalBalance._amount}
            </div>
          </div>
          <a
            href="https://telegra.ph/Pollo-Rules-07-17"
            target="_blank"
            className={styles.question}
            rel="noreferrer"
          >
            ?
          </a>
        </div>
      )}
      {showOpinionSliderCloseButton && (
        <div className={styles.close} onClick={onCloseClick}>
          <CloseIcon />
        </div>
      )}
    </header>
  );
});
